import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { InfoComponent } from "@components/info/info.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { LabelComponent } from "@components/label/label.component";
import { ProduktlarmDTO } from "~app/common/models/produkt/ProduktlarmDTO";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ProduktDetailTexts } from "../../../produkt-detail.texts";
import { ProduktDetailUppfoljningProduktlarmValidation } from "./produkt-detail-uppfoljning-produktlarm.validation";

@Component({
    selector: "rask-produkt-detail-uppfoljning-produktlarm",
    templateUrl: "./produkt-detail-uppfoljning-produktlarm.component.html",
    styleUrls: ["./produkt-detail-uppfoljning-produktlarm.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        LabelComponent,
        InputNumberComponent,
        InfoComponent
    ]
})
export class ProduktDetailUppfoljningProduktlarmComponent implements OnInit, OnDestroy {
    form: UntypedFormGroup;
    @Input() produktlarm: ProduktlarmDTO;
    @Input() rootForm: UntypedFormGroup;
    texts = ProduktDetailTexts.uppfoljningTab.texts;
    validation: IValidationScope;
    validationContext: IValidationContext;

    private readonly fieldsToUseInForm = [
        "varningsniva",
        "larmniva"
    ];
    private readonly formBinder = inject(FormBinderService);

    private formId: string;

    get infotext(): string {
        switch (this.produktlarm.typ) {
            case "LANGDFORDELNING":
                return this.texts.langdfordelningForklaring;
            case "DIAMETERFORDELNING":
                return this.texts.diameterfordelningForklaring;
            case "FORDELNINGSGRAD":
                return this.texts.fordelningsgradForklaring;
            case "VRAKANDEL":
                return this.texts.vrakandelForklaring;
            case "MANUELLAKAP":
                return this.texts.manuellaKapForklaring;
            case "FUKTHALTANDEL":
                return this.texts.fukthaltandelForklaring;
            case "FLISSTORLEKANDEL":
                return this.texts.flisstorlekandelForklaring;
            default:
                return "";
        }
    }

    get larmnamn(): string {
        switch (this.produktlarm.typ) {
            case "LANGDFORDELNING":
                return this.texts.langdfordelning;
            case "DIAMETERFORDELNING":
                return this.texts.diameterfordelning;
            case "FORDELNINGSGRAD":
                return this.texts.fordelningsgrad;
            case "VRAKANDEL":
                return this.texts.vrakandel;
            case "MANUELLAKAP":
                return this.texts.manuellaKap;
            case "FUKTHALTANDEL":
                return this.texts.fukthaltandel;
            case "FLISSTORLEKANDEL":
                return this.texts.flisstorlekandel;
            default:
                return "";
        }
    }

    ngOnDestroy(): void {
        this.formBinder
            .detachFromRootForm(this.rootForm, this.formId);
    }

    ngOnInit(): void {
        this.formId = `produkt-detail-tab-uppfoljning-produktlarm-${this.produktlarm.typ}`;
        this.createForm();
    }

    private createForm(): void {
        this.form = this.formBinder.CreateGroup(this.produktlarm, this.fieldsToUseInForm);

        this.validationContext = ProduktDetailUppfoljningProduktlarmValidation.init(this.produktlarm);
        this.validationContext.scope(ValidationScopes.spara).subscribe((v) => (this.validation = v));
        this.formBinder.attachValidation(this.validationContext.current, this.form);
        this.form.markAsPristine();

        this.rootForm.addControl(this.formId, this.form);
    }
}
